import React from "react";
import "./style.scss";
import chatImage from "../../../assets/img/chat.png";

const SupportChat = () => {
  return (
    <div className="support-chat">
      <div className="header">
        <h1 className="title">Canal de atendimento</h1>

        <h1 className="white-text">
          Caso não tenha encontrado sua dúvida no nosso FAQ, basta enviar um e-mail para suporte@motumbrasil.com ou clicar no icone de chat no canto inferior direito da sua tela para falar com um de nossos atendentes.
        </h1>
      </div>

      <img src={chatImage} alt="ilustração do chat" className="chat-image" />
    
    </div>
  );
};

export default SupportChat;
